import React, { ReactNode } from 'react';
import { useTransition, animated } from '@react-spring/web';

export const ModalAnimated: React.FC<{
    show: boolean;
    children: ReactNode;
    onDestroy(): void;
}> = ({ show, children, onDestroy }) => {
    const transitions = useTransition(show, {
        from: { transform: 'translate3d(0,-100%,0)', opacity: 0 },
        enter: { transform: 'translate3d(0,0px,0)', opacity: 1 },
        leave: { transform: 'translate3d(0,-100%,0)', opacity: 0.5 },
        onDestroyed: () => onDestroy && onDestroy(),
    });

    return transitions(
        (styles, item) =>
            item && <animated.div style={{ ...styles, height: '100%' }}>{children}</animated.div>
    );
};
